export const STATEMENT_END_VISIT_ID = 10000;
export const STATEMENT_END_LOCATION_ID = 10001;
export const KPI_COM_END_VISIT_ID = 115;
export const KPI_COM_END_LOCATION_ID = 37;
export const KPI_RECADRAGE_GSK_ID = 602;
export const SERVICES = {
  KPI: 1,
  Dimensions: 2,
  Client: 3,
  PDC: 4,
  Secto: 5,
  Modele: 6,
  Planification: 7,
  Formulaire: 8,
  Statistiques: 9,
  Phototeque: 10,
  Visites: 11,
  Privileges: 12,
  Virement: 32,
  Primes: 35,
  Conges: 38,
  NDF: 41,
  Presence: 44
};
export const ACCESS = {
  creation: "creation",
  modification: "modification",
  consultation: "consultation",
  suppression: "suppression",
  download: "download",
  export: "export"
};
export const NATURE_EVENT_ID = 1;
export const NATURE_PRESENCE_ID = 2;
export const NATURE_MERCH_ID = 3;

export const ASAHI_ID = 1;
export const DELONGHI_ID = 2;
export const ECOSYSTEM_ID = 3;
export const HAGER_ID = 4;
export const POLTI_ID = 6;
export const HTC_ID = 7;
export const ROC_ID = 9;
export const HILLROM_ID = 10;
export const DPN_ID = 11;
export const GSK_ID = 13;
export const SB1_ID = 15;
export const NEW_FLAG_ID = 16;
export const GSK_PHARMA_ID = 17;
export const MEME_ID = 18;
export const BULK_ID = 20;
export const sources = {
  PRODUCT: "Product",
  FAMILY: "family",
  LOCATION_TYPE: "LocationType",
  PDC: "PDC",
  VISIT: "visit",
  CATEGORY: "category",
  BRAND: "brand",
  VENDOR: "vendor",
  equals: (s1 = "", s2 = "") => {
    if (s1 === null || s2 === null) return false;
    return s1.toLowerCase() === s2.toLowerCase();
  }
};

export const roles = {
  CLIENT: 5,
  TERRAIN: 4,
  MANAGER: 3,
  DIRECTOR: 2,
  ADMIN: 1
};

export const requests = {
  PDC_CREATION: "pdc_creation",
  PDC_UPDATE: "pdc_update",
  SECTOR_ADD_USER: "sector_add_user"
};

export const requests_label = {
  pdc_creation: "création de pdc",
  pdc_update: "mise à jour de pdc"
};
export const CLIENTS_LIST = [
  {
    _id: "5f5f1b8c4de98e00120e4b7c",
    label: "ASAHI",
    idClient: 1
  },
  {
    _id: "5f5f1b8c4de98e00120e4b7d",
    label: "DELONGHI",
    idClient: 2
  },
  {
    _id: "5f5f1b8c4de98e00120e4b7e",
    label: "ECOSYSTEM",
    idClient: 3
  },
  {
    _id: "5f5f1b8c4de98e00120e4b7f",
    label: "HAGER",
    idClient: 4
  },
  {
    _id: "5f5f1b8c4de98e00120e4b80",
    label: "BMF",
    idClient: 5
  },
  {
    _id: "5f5f1b8c4de98e00120e4b81",
    label: "POLTI",
    idClient: 6
  },
  {
    _id: "5f5f1b8c4de98e00120e4b82",
    label: "HTC",
    idClient: 7
  },
  {
    _id: "5f5f1b8c4de98e00120e4b83",
    label: "GROHE",
    idClient: 8
  },
  {
    _id: "5f5f1b8c4de98e00120e4b84",
    label: null,
    idClient: 9
  },
  {
    _id: "5f5f1b8c4de98e00120e4b85",
    label: null,
    idClient: 10
  },
  {
    _id: "5f5f1b8c4de98e00120e4b86",
    label: "DPN",
    idClient: 11
  },
  {
    _id: "5f5f1b8c4de98e00120e4b87",
    label: null,
    idClient: 12
  },
  {
    _id: "5f5f1b8c4de98e00120e4b88",
    label: "GSK_SGP",
    idClient: 13
  },
  {
    _id: "5f5f1b8c4de98e00120e4b89",
    label: null,
    idClient: 14
  },
  {
    _id: "5f5f1b8c4de98e00120e4b8a",
    label: "SB1",
    idClient: 15
  },
  {
    _id: "5f5f1b8c4de98e00120e4b8b",
    label: null,
    idClient: 16
  },
  {
    _id: "5f5f1b8c4de98e00120e4b8c",
    label: "GSK_PHARMA",
    idClient: 17
  },
  {
    _id: "5f5f1b8c4de98e00120e4b8d",
    label: "ECOSYSTEM ENQUETE",
    idClient: 103
  }
];

export const DATE_SLOTS = {
  MORNING: "MORNING",
  AFTERNOON: "AFTERNOON"
};

export const slotId = {
  MORNING: 1,
  AFTERNOON: 2
};

export const slotFromId = {
  1: "MORNING",
  2: "AFTERNOON"
};

export const slotData = {
  [slotId.MORNING]: {
    id: slotId.MORNING,
    label: "matin"
  },
  [slotId.AFTERNOON]: {
    id: slotId.AFTERNOON,
    label: "après-midi"
  }
};

export const VACATION_REQUEST_STATUS_ID = {
  PENDING: 1,
  VALIDATED: 2,
  REJECTED: 3,
  CANCELED: 4
};

export const VACATION_REQUEST_STATUS_LABELS = {
  PENDING: "En attente de validation",
  VALIDATED: "Validé",
  REJECTED: "Refusé",
  CANCELED: "Supprimé"
};

export const PRESENCE_STATUS_ID = {
  ATTENDANCE: 1,
  ABSENCE: 2,
  VACATION: 3,
  NON_WORK: 4
};

export const PRESENCE_STATUS_LABEL = {
  ATTENDANCE: "Présence",
  ABSENCE: "Absence",
  VACATION: "Congés",
  NON_WORK: "Non travaillé"
};

export const TRIP_TYPE_ID = {
  PRO: 1,
  PERSO: 2
};

export const EXPENSE_STATUS_ID = {
  PENDING: 1,
  PREVALIDATED: 2,
  VALIDATED: 3,
  REFUSED: 4,
  REJECTED: 5,
  DELETED: 6,
  REFUND: 7
};

export const EXPENSE_STATUS_LABEL = {
  PENDING: "En attente",
  PREVALIDATED: "Accepté",
  VALIDATED: "Validé",
  REFUND: "Remboursée",
  REFUSED: "Refusé",
  REJECTED: "Rejeté",
  DELETED: "Supprimé"
};

export const EXPENSE_STATUS_ID_TO_LABEL = {
  1: "En attente",
  2: "Acceptée",
  3: "Validée",
  4: "Refusée",
  5: "Rejetée",
  6: "Supprimée",
  7: "Remboursée"
};

export const PREMIUM_STATUS = {
  1: "en attente",
  2: "validée",
  3: "rejetée",
  4: "supprimée"
};

export const BONUS_TYPE_ID = {
  REGULAR: 1,
  EXTRA: 2
};

export const BONUS_TYPE_LABEL = {
  EXTRA: "Exceptionnelle",
  REGULAR: "Normale"
};

export const BONUS_TYPE_LABEL_TO_ID = {
  Normale: 1,
  Exceptionnelle: 2
};

export const BONUS_STATUS_ID = {
  PENDING: 1,
  VALIDATED: 2,
  REJECTED: 3,
  DELETED: 4
};

export const FREQUENCY_ID = {
  MONTHLY: 1,
  QUARTERLY: 2
};
export const FREQUENCY_LABEL = {
  MONTHLY: "mensuelle",
  QUARTERLY: "trimestrielle"
};

export const FREQUENCY_ID_TO_LABEL = {
  1: "mensuel",
  2: "trimestriel"
};

export const CODE_AUTH_GOOGLE_INVALID_ACCESS_TOKEN = 100;
export const CODE_AUTH_GOOGLE_UNKNOWN_USER = 101;
export const CODE_AUTH_INVALID_ACCESS_TOKEN = 102;
export const CODE_AUTH_REQIURED = 103;
export const CODE_VALIDATION_FAILED = 104;
export const CODE_EVENT_NOT_DELETABLE = 105;



// WEBPACK FOOTER //
// src/configs/constants.js